// Steam login always lands on /steam/callback, which used to send everyone to the front page.
// A page that asks the visitor to log in can remember where they were, and the callback sends
// them back there. sessionStorage survives the Steam round trip because it stays in the same tab.

const KEY = "powerstats_login_return";

export const rememberLoginReturn = (path: string) => {
    try {
        sessionStorage.setItem(KEY, path);
    } catch {
        // Storage blocked: the visitor just lands on the front page as before.
    }
};

// The callback is a full page load, so this is fresh per login. Kept so a second call (StrictMode
// runs effects twice in development) gets the same answer instead of the already-cleared "/".
let taken: string | null = null;

/** The remembered same-site path (cleared from storage), or "/" when there is none. */
export const takeLoginReturn = (): string => {
    if (taken !== null) return taken;
    taken = "/";
    try {
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        if (path && path.startsWith("/") && !path.startsWith("//")) taken = path;
    } catch {
        // Fall through to the front page.
    }
    return taken;
};
